import Swiper, {Autoplay, Navigation, Pagination} from "swiper";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

Swiper.use([Navigation, Pagination, Autoplay])
window.swiper = Swiper
export const slideshow = () => {
    new Swiper('.slideshow', {
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".slideshow .swiper-button-next",
            prevEl: ".slideshow .swiper-button-prev",
        },
    })
    new Swiper('.product_slider', {
        // autoplay: {
        //     delay: 3500,
        //     disableOnInteraction: false,
        // },
        loop: true,
        navigation: {
            nextEl: ".product_slider .swiper-button-next",
            prevEl: ".product_slider .swiper-button-prev",
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
            1280: {
                slidesPerView: 5,
                spaceBetween: 10,
            }
        }
    })
    new Swiper('.product_bestseller', {
        // autoplay: {
        //     delay: 3500,
        // },
        loop: true,
        navigation: {
            nextEl: ".product_bestseller .swiper-button-next",
            prevEl: ".product_bestseller .swiper-button-prev",
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            1280: {
                slidesPerView: 5,
                spaceBetween: 10,
            }
        }
    })
    new Swiper(document.getElementById('product_viewed'), {
        navigation: {
            nextEl: ".button-prev",
            prevEl: ".button-next",
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            1280: {
                slidesPerView: 5,
                spaceBetween: 10,
            }
        }
    })
    new Swiper(document.getElementById('product_featured'), {
        navigation: {
            nextEl: ".buttonp-prev",
            prevEl: ".buttonp-next",
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            1280: {
                slidesPerView: 5,
                spaceBetween: 10,
            }
        }
    })
    new Swiper('.carousel', {
        autoplay: {
            delay: 2500,
        },
        loop: true,
        navigation: {
            nextEl: ".carousel .swiper-button-next",
            prevEl: ".carousel .swiper-button-prev",
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            1280: {
                slidesPerView: 5,
                spaceBetween: 10,
            }
        }
    })
    new Swiper('.reviews', {
        slidesPerView: 1,
        spaceBetween: 40,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        loop: true,
        pagination: {
            el: ".reviews .swiper-pagination",
            clickable: true,
        }
    })
    new Swiper('.echivalente', {
        autoplayDisableOnInteraction:true,
        navigation: {
            nextEl: ".echivalente .swiper-button-next",
            prevEl: ".echivalente .swiper-button-prev",
        },
        spaceBetween: 10,
        breakpoints: {
            380: {
                slidesPerView: 2
            },
            640: {
                slidesPerView: 4
            },
            1024: {
                slidesPerView: 5
            },
            1280: {
                slidesPerView: 7
            }
        }
    })
    new Swiper('.oems', {
        spaceBetween: 20,
        autoplayDisableOnInteraction:true,
        navigation: {
            nextEl: ".oems .swiper-button-next",
            prevEl: ".oems .swiper-button-prev",
        },
        breakpoints: {
            640: {
                slidesPerView: 1
            },
            1024: {
                slidesPerView: 3
            },
            1280: {
                slidesPerView: 4
            }
        }
    })
}